import {
  INSITUTION_LIST_REQUEST,
  INSITUTION_LIST_SUCCESS,
  INSITUTION_LIST_FAILURE,
  CLEAR_INSITUTION_LIST,
  
  CREATE_INSITUTION_REQUEST,
  CREATE_INSITUTION_SUCCESS,
  CREATE_INSITUTION_FAILURE,

  DISTRICT_LIST_REQUEST,
  DISTRICT_LIST_SUCCESS,
  DISTRICT_LIST_FAILURE,

  SPORT_LIST_REQUEST,
  SPORT_LIST_SUCCESS,
  SPORT_LIST_FAILURE,

  AMENITIES_LIST_REQUEST,
  AMENITIES_LIST_SUCCESS,
  AMENITIES_LIST_FAILURE,

  CREATE_INSITUTION_DOC_REQUEST,
  CREATE_INSITUTION_DOC_SUCCESS,
  CREATE_INSITUTION_DOC_FAILURE,

  CORRECTION_LIST_REQUEST,
  CORRECTION_LIST_SUCCESS,
  CORRECTION_LIST_FAILURE,
  
} from "./actionTypes";

const initialState = {
  ISLOADING: false,
  ISFAILURE: false,
  ALL_INSITUTION_LIST: [],
  DISTRICT_LIST: [],
  SPORT_LIST: [],
  AMENITIES_LIST: [],
  CORRECTION_LIST: [],
  ISUPDATING: false,
  ISUPDATE_SUCCESS: false,
  ISUPDATE_FAILURE: false,
};

export function ALL_INSITUTION_LISTreducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    // 📦 Institution List Cases
    case INSITUTION_LIST_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case INSITUTION_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        ALL_INSITUTION_LIST: payload,
        ISFAILURE: false,
      };

    case INSITUTION_LIST_FAILURE:
      return { ...state, ISLOADING: false, ISFAILURE: true };

      case CLEAR_INSITUTION_LIST:
        return {
          ...state,
          ALL_INSITUTION_LIST: [],
        };  

    // ➕ Institution Create Cases
    case CREATE_INSITUTION_REQUEST:
      return {
        ...state,
        ISCREATING: true,
        ISCREATE_SUCCESS: false,
        ISCREATE_FAILURE: false,
      };

    case CREATE_INSITUTION_SUCCESS:
      return {
        ...state,
        ISCREATING: false,
        ISCREATE_SUCCESS: true,
        ISCREATE_FAILURE: false,
      };

    case CREATE_INSITUTION_FAILURE:
      return {
        ...state,
        ISCREATING: false,
        ISCREATE_SUCCESS: false,
        ISCREATE_FAILURE: true,
      };

    // 📍 District List Cases
    case DISTRICT_LIST_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case DISTRICT_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        DISTRICT_LIST: payload,
        ISFAILURE: false,
      };

    case DISTRICT_LIST_FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISFAILURE: true,
      };

    case SPORT_LIST_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case SPORT_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        SPORT_LIST: payload, // You can initialize SPORT_LIST: [] in initialState
        ISFAILURE: false,
      };

    case SPORT_LIST_FAILURE:
      return { ...state, ISLOADING: false, ISFAILURE: true };

    // 🏠 Amenities List Cases
    case AMENITIES_LIST_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case AMENITIES_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        AMENITIES_LIST: payload,
        ISFAILURE: false,
      };

    case AMENITIES_LIST_FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISFAILURE: true,
      };

    // ➕ Institution Document Create Cases
    case CREATE_INSITUTION_DOC_REQUEST:
      return {
        ...state,
        ISCREATING: true,
        ISCREATE_SUCCESS: false,
        ISCREATE_FAILURE: false,
      };

    case CREATE_INSITUTION_DOC_SUCCESS:
      return {
        ...state,
        ISCREATING: false,
        ISCREATE_SUCCESS: true,
        ISCREATE_FAILURE: false,
      };

    case CREATE_INSITUTION_DOC_FAILURE:
      return {
        ...state,
        ISCREATING: false,
        ISCREATE_SUCCESS: false,
        ISCREATE_FAILURE: true,
      };

    // 📍 Correction List Cases
    case CORRECTION_LIST_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };

    case CORRECTION_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        CORRECTION_LIST: payload,
        ISFAILURE: false,
      };

    case CORRECTION_LIST_FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISFAILURE: true,
      };

    default:
      return state;
  }
}
